import type { commonApiV1 } from '@deepup/apis';
import { structApi } from '@deepup/apis';
import type { BoundingBox } from '@viewer3D/types';
import { xyToLngLat } from './spacial-ref-converter';

/**
 * Converts a BoundingBox (in projected X/Y coordinates) to a GeoJSON Geometry with bbox field
 * The backend only uses the bbox field for bounding box filtering
 *
 * Format: [minLng, minLat, maxLng, maxLat]
 */
export const boundingBoxToGeometry = (bbox: BoundingBox): commonApiV1.Geometry => {
  // Convert projected X/Y coordinates to lng/lat
  const { lng: minLng, lat: minLat } = xyToLngLat({ x: bbox.minX, y: bbox.minY });
  const { lng: maxLng, lat: maxLat } = xyToLngLat({ x: bbox.maxX, y: bbox.maxY });

  // bbox format: [minLng, minLat, maxLng, maxLat]
  const bboxArray = [minLng, minLat, maxLng, maxLat];

  return {
    type: 'Polygon',
    bbox: structApi.ListValue.fromJson(bboxArray),
    geometries: [],
  };
};
